<template>
  <a-row :gutter="[0, 16]">
    <a-col span="24">
      <a-card id="mark-objects-card" size="small" :bordered="false">
        <template #title>
          <a-space :size="10">
            <a-typography-title :level="5" style="display: inline">
              Enable all features
            </a-typography-title>
            <a-checkbox
              v-model:checked="allSelected"
              @change="handleSelectAllChange"
            >
            </a-checkbox>
          </a-space>
        </template>

        <a-list
          id="advance-feature-list"
          item-layout="horizontal"
          bordered
          :data-source="advanceFeaturesConfig"
        >
          <template #renderItem="{ item, index }">
            <a-list-item
              :key="item"
              class="feature-item-select"
              @click="updateSelectedFeature(item)"
            >
              <a-typography-title :level="5" style="display: inline">{{
                item
              }}</a-typography-title>
              <template #actions>
                <a-checkbox
                  v-model:checked="selectedFeature[item]"
                  @change="isAllFeatureSelected"
                />
              </template>
            </a-list-item>
          </template>
        </a-list>
      </a-card>
    </a-col>
    <a-col span="24" class="d-flex">
      <a-space class="ml-auto">
        <a-button
          id="advance-feature-save-button"
          type="primary"
          :loading="isSaveLoading"
          @click="saveAdvanceFeature"
        >
          {{ isSaveLoading ? 'Applying Changes...' : 'Save' }}
        </a-button>
      </a-space>
    </a-col>
  </a-row>
</template>

<script>
import advanceFeaturesConfig from 'src/config/advance-features-config';
import { getAdvanceFeaturesJSON } from 'src/utils/task';
import { mapActions, mapGetters } from 'vuex';
export default {
  inject: ['toast'],

  setup() {
    return {
      advanceFeaturesConfig,
    };
  },

  data() {
    return {
      selectedFeature: [],
      allSelected: false,
      isSaveLoading: false,
      cardBodyStyle: {
        flexGrow: '1',
        height: '1px',
        overflowY: 'auto',
        overflowX: 'hidden',
      },
    };
  },

  computed: {
    ...mapGetters(['advanceFeatures']),
  },

  mounted() {
    this.addSelectedFeature();
    this.isAllFeatureSelected();
  },

  methods: {
    ...mapActions(['setAdvanceFeatures']),

    async saveAdvanceFeature() {
      this.isSaveLoading = true;
      const result = await this.setAdvanceFeatures({ ...this.selectedFeature });
      this.isSaveLoading = false;
      if (!result) this.toast.error('Failed to save advance feature settings.');
      else this.toast.success('Advance feature settings saved successfully.');
    },

    addSelectedFeature() {
      this.selectedFeature = getAdvanceFeaturesJSON();
      for (const [key, value] of Object.entries(this.advanceFeatures)) {
        this.selectedFeature[key] = value;
      }
    },

    updateSelectedFeature(item) {
      this.selectedFeature[item] = !this.selectedFeature[item];
      this.isAllFeatureSelected();
    },

    isAllFeatureSelected() {
      this.allSelected = Object.values(this.selectedFeature).every(
        (value) => value === true
      );
    },

    handleSelectAllChange() {
      Object.keys(this.selectedFeature).forEach((key) => {
        this.selectedFeature[key] = this.allSelected;
      });
    },
  },
};
</script>

<style scoped>
.feature-item-select {
  cursor: pointer;
}
.feature-item-select:hover {
  background-color: #f5f5f5;
}
#mark-objects-card > .ant-card-body {
  padding: 0px !important;
}
</style>
